export default __webpack_public_path__ + "static/media/home-travel-agency-about-bg.aa5cc312.jpg";